import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import callapi from '../../helpers/callapi'
import config from '../../config'
import Cookies from 'js-cookie'
import { debounce } from 'lodash'
import { useDispatch } from 'react-redux'
import { getPublicUrl, getUploadImageUrl } from '../../helpers/url'
import Swal from 'sweetalert2'
import { createFirebaseCloudMessaging } from './services'

const { apiAdminGateway = '' } = config

export default function FCMCreateForm({ isShow, onCancel, onSend, onHide }) {
  const topicRef = useRef(null)
  const titleRef = useRef(null)
  const bodyRef = useRef(null)
  const imageRef = useRef(null)
  const [imageUrl, setImageUrl] = useState('')
  const scheduleRef = useRef(null)
  const publicDateRef = useRef(null)
  const publicTimeRef = useRef(null)
  const [countText, setCountText] = useState(0)
  const [isSchedule, setIsSchedule] = useState(false)
  const [topics, setTopics] = useState([])
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const reset = () => {
    setIsSchedule(false)
    topicRef.current.value = ''
    titleRef.current.value = ''
    titleRef.current.focus()
    imageRef.current.value = ''
    setImageUrl('')
    bodyRef.current.value = ''
    setCountText(0)
    scheduleRef.current.checked = false
    if (publicDateRef && publicDateRef.current) publicDateRef.current.value = ''
    if (publicTimeRef && publicTimeRef.current) publicTimeRef.current.value = ''
  }

  const handleOnClickSend = () => {
    if (!titleRef.current.value) {
      titleRef.current.focus()
      alert('กรุณาระบุหัวข้อที่ต้องการส่งด้วยค่ะ')
      return
    }
    if (!bodyRef.current.value) {
      bodyRef.current.focus()
      alert('กรุณาระบุรายละเอียดด้วยค่ะ')
      return
    }
    if (isSchedule) {
      const selectDate = new Date(`${publicDateRef.current.value} ${publicTimeRef.current.value}`)
      const currentDate = new Date()

      if (!publicDateRef.current.value) {
        publicDateRef.current.focus()
        alert('กรุณาเลือกวันที่ในการเผยแพร่')
        return
      }
      if (!publicTimeRef.current.value) {
        publicTimeRef.current.focus()
        alert('กรุณาเลือกเวลาในการเผยแพร่')
        return
      }
      if (selectDate < currentDate) {
        alert('วันที่และเวลาต้องไม่น้อยกว่า วันที่และเวลาปัจจุบัน')
        return
      }
    }

    const schedule = isSchedule
      ? new Date(`${publicDateRef.current.value} ${publicTimeRef.current.value}`).toISOString()
      : new Date().toISOString()

    const body = {
      payload: {
        to: topicRef.current.value,
        messages: {
          title: titleRef.current.value,
          body: bodyRef.current.value,
        },
        imageUrl: imageUrl,
        published: schedule,
      },
      schedule: schedule,
      eventType: 'FCM',
    }
    setIsLoading(true)
    createFirebaseCloudMessaging(body)
      .then((response) => {
        reset()
        const alertMessage = isSchedule
          ? 'ระบบได้ทำการบันทึกเรียบร้อยแล้วค่ะ'
          : 'ระบบได้ทำการส่งข้อความให้เรียบร้อยแล้วค่ะ'
        alert(alertMessage)
        if (typeof onSend === 'function') {
          onSend(response)
        }
      })
      .catch((err) => {
        console.log(err)
        alert(err?.reason?.message ?? err.message)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleOnClickCancel = () => {
    reset()
    if (typeof onCancel === 'function') onCancel()
  }

  const debounceOnClickSend = debounce(handleOnClickSend, 300)

  const debounceOnClickCancel = debounce(handleOnClickCancel, 300)

  const handleUploadImage = async (event) => {
    const file = event.target.files[0]

    if (!file) {
      imageRef.current.value = null
      return
    }

    try {
      dispatch({ type: 'loading_show' })

      const url = await getUploadImageUrl()
      const imageUrl = getPublicUrl(url)

      const response = await fetch(url, {
        method: 'PUT',
        body: file,
      })

      if (!response.ok) throw new Error('Error uploading image')

      setImageUrl(imageUrl)
    } catch (error) {
      console.error(error)

      setImageUrl('')
      if (imageRef.current) {
        imageRef.current.value = null
      }

      Swal.fire({
        title: 'ไม่สามารถเพิ่มรูปภาพได้',
        html: 'กรุณาตรวจสอบขนาดไฟล์และ<br>นามสกุลไฟล์ที่รองรับ',
        icon: 'error',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const topicAll = async () => {
    const res = await callapi({
      fullURL: `${apiAdminGateway}/api/v1/admin/notification/fcm/topic`,
      method: 'get',
      headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
    })
      .then((res) => {
        const { data } = res
        setTopics(data)
      })
      .catch((err) => {
        return err
      })
    return res
  }

  useEffect(() => {
    if (titleRef && titleRef.current) titleRef.current.focus()
    topicAll().catch((err) => {
      alert(err)
    })
  }, [isShow])

  const topicAllData = () => {
    if (topics.length > 0) {
      return topics.map((topic, i) => {
        return (
          <option key={`topic_option_${i}`} value={topic.name}>
            {topic.name}
          </option>
        )
      })
    }
  }

  return (
    <>
      <Modal show={isShow} size="xl" onHide={onHide}>
        <Modal.Header>
          <Modal.Title>ฟอร์ม สร้างการแจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>ช่องทาง</Form.Label>
              <select ref={topicRef} className="form-control">
                {topicAllData()}
              </select>
              <Form.Text></Form.Text>
            </Form.Group>
            <Form.Group>
              <Form.Label>หัวข้อ</Form.Label>
              <input ref={titleRef} className="form-control" />
              <Form.Text></Form.Text>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col>
                  <Form.Label>รายละเอียด</Form.Label>
                </Col>
                <Col className="d-flex justify-content-end">({countText}/4,000 Characters)</Col>
              </Row>
              <textarea
                rows={3}
                className="form-control"
                ref={bodyRef}
                onChange={(e) => setCountText(e.target.value.length)}
              />
              <Form.Text></Form.Text>
            </Form.Group>
            <Form.Group style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Form.Label>URL รูปภาพ</Form.Label>
              <input ref={imageRef} type="file" onChange={handleUploadImage} accept="image/jpeg, image/jpg" />
              {imageUrl && <img width="100%" src={imageUrl} alt="preview" />}
            </Form.Group>
            <Form.Group>
              {/* <Form.Label>ตั้งเวลา</Form.Label> */}
              <div className="custom-control custom-switch toggle-switch mr-4 mb-2 mt-4">
                <input
                  ref={scheduleRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="customSwitch11"
                  onClick={() => setIsSchedule((prev) => !prev)}
                />
                <label className="custom-control-label" htmlFor="customSwitch11">
                  ตั้งเวลา
                </label>
              </div>
            </Form.Group>
            {isSchedule && (
              <Form.Group>
                <Form.Label>เลือกวันที่/เวลา</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type="date"
                      min={new Date().toISOString().slice(0, 10)}
                      ref={publicDateRef}
                    ></Form.Control>
                  </Col>
                  <Col>
                    <Form.Control type="time" ref={publicTimeRef}></Form.Control>
                  </Col>
                </Row>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn" onClick={debounceOnClickCancel} disabled={isLoading}>
            ยกเลิก
          </button>
          <button className="btn btn-primary" onClick={debounceOnClickSend} disabled={isLoading}>
            {isLoading ? '.....' : 'ส่ง'}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
